export default function About() {
  return (
    <section id="about" className="py-20 border-t border-line">
      <div className="container-narrow">
        <h2 className="page-heading">About me</h2>
        <div className="space-y-4 leading-relaxed">
          <p>
            I'm a Biomedical Engineering student at the University of Waterloo,
            working mostly on machine learning and data engineering.
          </p>
          <p>
            In my free time I really enjoy going to the gym and playing table
            tennis, and was previously a player on the Canadian National Team.
          </p>
        </div>
      </div>
    </section>
  );
}
